"use strict";

var _interopRequireWildcard = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Levels = void 0;
var _slicedToArray2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _react = _interopRequireWildcard(require("react"));
var _levelsModule = _interopRequireDefault(require("./levels.module.scss"));
var _reactMeasure = _interopRequireDefault(require("react-measure"));
var _caretRight = require("../../assets/icons/caret-right.svg");
var _useCalculatedItems2 = _interopRequireDefault(require("./hooks/useCalculatedItems"));
var _MoreTooltip = require("./more-tooltip/MoreTooltip");
var _Measurer = require("./measurer/Measurer");
var _classnames = _interopRequireDefault(require("classnames"));
var defaultItems = [];
var Levels = function Levels(_ref) {
  var _ref$items = _ref.items,
    items = _ref$items === void 0 ? defaultItems : _ref$items,
    _ref$showFirst = _ref.showFirst,
    showFirst = _ref$showFirst === void 0 ? false : _ref$showFirst,
    tooltipPosition = _ref.tooltipPosition,
    className = _ref.className;
  var _useState = (0, _react.useState)(0),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    containerWidth = _useState2[0],
    setContainerWidth = _useState2[1];
  var _useState3 = (0, _react.useState)({}),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    itemsWidths = _useState4[0],
    setItemsWidths = _useState4[1];
  var handleContainerResize = (0, _react.useCallback)(function (_ref2) {
    var bounds = _ref2.bounds;
    setContainerWidth(bounds.width);
  }, []);
  var _useCalculatedItems = (0, _useCalculatedItems2.default)(items, itemsWidths, containerWidth, showFirst),
    calculatedItems = _useCalculatedItems.calculatedItems,
    shortened = _useCalculatedItems.shortened,
    isContainerOverflowed = _useCalculatedItems.isContainerOverflowed;
  return /*#__PURE__*/_react.default.createElement(_reactMeasure.default, {
    bounds: true,
    onResize: handleContainerResize
  }, function (_ref3) {
    var measureRef = _ref3.measureRef;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(_levelsModule.default['levels'], className),
      "data-testid": "levels",
      ref: measureRef
    }, items.length > 0 && /*#__PURE__*/_react.default.createElement("div", {
      "data-testid": "levels-container",
      className: _levelsModule.default['levels__container']
    }, showFirst && shortened && isContainerOverflowed && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      className: _levelsModule.default['levels__item'],
      title: items[0]
    }, items[0]), /*#__PURE__*/_react.default.createElement(_caretRight.ReactComponent, {
      className: _levelsModule.default['levels__arrow']
    })), shortened && /*#__PURE__*/_react.default.createElement(_MoreTooltip.MoreTooltip, {
      items: items,
      position: tooltipPosition
    }), calculatedItems.map(function (item, index) {
      return /*#__PURE__*/_react.default.createElement(_react.Fragment, {
        key: index
      }, (index > 0 || shortened) && /*#__PURE__*/_react.default.createElement(_caretRight.ReactComponent, {
        className: _levelsModule.default['levels__arrow']
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: _levelsModule.default['levels__item'],
        title: item
      }, item));
    })), /*#__PURE__*/_react.default.createElement(_Measurer.Measurer, {
      items: items,
      widths: itemsWidths,
      className: _levelsModule.default['levels__measurer'],
      itemsClassName: _levelsModule.default['levels__measurer-item'],
      onResize: setItemsWidths
    }));
  });
};
exports.Levels = Levels;